import {observer} from "mobx-react";
import React from "react";
import {Modal} from "@mui/material";
import {isEqual} from "lodash";
import {
	CloseBtn,
	ModalBody,
	ModalBox,
	ModalContent,
	ModalFooter,
	ModalHeader,
	ModalText,
	ModalTitle,
} from "views/components/modals/common/common.component";
import {useViewController} from "data/services/locator";
import {IModalsController} from "views/controllers/modals/modals.controller";
import {Bindings} from "data/constants/bindings";
import {ModalType} from "data/enums";
import {ReactComponent as PickemLogo} from "assets/img/gamezone/pickem_logo_dark.svg";
import {ReactComponent as IconClose} from "assets/img/icon/close.svg";
import {PrimaryButton} from "views/components/style";
import styled from "@emotion/styled";

const PickemLogoStyled = styled(PickemLogo)`
	max-width: 220px;
`;

export const WelcomeModal: React.FC = observer(() => {
	const controller = useViewController<IModalsController>(Bindings.ModalsController);
	const {i18n, visibleModal, close, onWelcomeCtaClick} = controller;
	const isVisible = isEqual(visibleModal, ModalType.WELCOME);

	if (!isVisible) {
		return null;
	}

	const title = i18n.t("modal.welcome.title", "Welcome to Your Picks!");
	const message = i18n.t(
		"modal.welcome.description",
		"Now is your chance to pick your ultimate team line-up for Rome and share your selections with family and friends. Get started by choosing who you would like to be your Automatic Qualifications and Captain's Picks for either team."
	);

	return (
		<Modal open={isVisible}>
			<ModalBox>
				<ModalContent>
					<ModalHeader>
						<PickemLogoStyled />
					</ModalHeader>
					<ModalBody>
						<ModalTitle>{title}</ModalTitle>
						<ModalText>{message}</ModalText>
					</ModalBody>
					<CloseBtn onClick={close}>
						<IconClose />
					</CloseBtn>
					<ModalFooter>
						<PrimaryButton
							fullWidth
							onClick={onWelcomeCtaClick}
							variant="contained"
							size="large">
							{i18n.t("modal.welcome.cta", "Play Now")}
						</PrimaryButton>
					</ModalFooter>
				</ModalContent>
			</ModalBox>
		</Modal>
	);
});
